<template>
  <div class="compilation-edit-toolbar">
    <BaseButton
      class="text-none button-add-section"
      color="primary"
      outlined
      @click="addSection"
    >
      <BaseSpriteIcon icon-name="ico-plus-solid" />
      {{ $t('CompilationFooter.addSection.button.label') }}
    </BaseButton>
    <div class="side-block">
      <BaseButton class="text-none primary--text" light text @click="cancel">
        {{ $t('Cancel') }}
      </BaseButton>
      <BaseButton
        class="text-none"
        color="primary"
        elevation="0"
        :disabled="isTitleEmpty || !isOnline"
        @click="saveChanges"
      >
        {{ $t('CompilationFooter.saveChanges.button.label') }}
      </BaseButton>
    </div>
  </div>
</template>
<script>
import GoogleAnalyticsUtils from '@/services/utils/GoogleAnalyticsUtils';
import AppStatesEnum from '@/enums/AppStateEnum.js';
import CompilationEditToolbarEvents from '@/enums/CompilationEditToolbarEvents';
import PopupNamesEnum from '@/enums/PopupNamesEnum';
import LoggerFactory from '@/services/utils/LoggerFactory';
const logger = LoggerFactory.getLogger('CompilationEditToolbar.vue');

import BaseButton from '@/components/base/BaseButton/BaseButton';
import BaseSpriteIcon from '@/components/base/BaseSpriteIcon/BaseSpriteIcon';

export default {
  components: {
    BaseButton,
    BaseSpriteIcon
  },
  props: {
    compilationId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isTitleEmpty: false
    };
  },
  computed: {
    editMeta() {
      return this.$store.getters['CompilationsStore/getEditMeta']();
    },
    isOnline() {
      return this.$store.getters['ContextStore/isOnline'];
    }
  },
  watch: {
    'editMeta.name'(newVal) {
      this.isTitleEmpty = typeof newVal === 'string' && newVal.trim() === '';
    }
  },
  methods: {
    addSection() {
      try {
        this.$store.dispatch('ManagePopupStore/openPopup', {
          name: PopupNamesEnum.CREATE_SECTION_POPUP,
          popupContext: {
            compilationId: this.compilationId
          }
        });
      } catch (err) {
        this.$_errorHandler(err);
      }
    },
    async saveChanges() {
      try {
        const isCompilationEmpty = this.$store.getters[
          'CompilationsStore/isCurrentCompilationEmpty'
        ];
        GoogleAnalyticsUtils.trackEvent('Compilation', 'save');
        await this.$store.dispatch('PublicationStore/saveMetaData', {
          compilationId: this.compilationId
        });
        this.$store.commit('PlaybackStore/setCurrentParaId', null);
        this.$store.commit('CompilationsStore/setIsEditMode', false);
        if (isCompilationEmpty) {
          this.$router.push({ name: AppStatesEnum.MANAGE_PUBLICATION });
        }
      } catch (err) {
        this.$_errorHandler(err);
      }
    },
    async cancel() {
      this.$store.commit('CompilationsStore/setIsEditMode', false);
    },
    $_errorHandler(error) {
      logger.error(`Error in CompilationEditToolbar: ${error.stack}`);
      this.emit(CompilationEditToolbarEvents.ERROR, { error });
    },
    emit(type, data) {
      this.$emit('compilationEditToolbarEvent', { type, data });
    }
  }
};
</script>

<style lang="less" scoped>
@import 'CompilationEditToolbar.less';
</style>
